import Repository from './Repository'
const action = 'total-search'

export default {
  getAllSearchResults(param) {
    return Repository.get(action + '?value=' + param)
  },
}
